var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.293,
    height: 10.45,
    viewBox: "0 0 6.293 10.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Union_12",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: "2px",
    d: "M4.028 4.639L.159 0l3.869 4.639.772-.867-.775.866.746.894-.746-.894L0 9.143z",
    "data-name": "Union 12",
    transform: "rotate(-180 2.774 4.905)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.01a7a7641249d13e0b9d37474b898384.svg";
export { ForwardRef as ReactComponent };